import { Empty, Spin } from 'antd';
import clsx from 'clsx';
import { Icon } from '../Core/Icon';
import { iconComponents } from '../Core/IconImports';

interface EmptyTableOverlayProps {
  isVisible: boolean;
  isLoading: boolean;
  icon: keyof typeof iconComponents;
  label: string;
}

const EmptyTableOverlay = ({
  isVisible,
  isLoading,
  icon,
  label,
}: EmptyTableOverlayProps) => {
  return (
    <div
      className={clsx(
        'absolute inset-0 z-[9] flex items-center justify-center',
        'bg-white',
        'backdrop-blur-none transition-[backdrop-filter,opacity] duration-200 ease-in-out',
        isVisible
          ? 'pointer-events-auto opacity-100 backdrop-blur-sm'
          : 'pointer-events-none opacity-0 backdrop-blur-none'
      )}
    >
      <Empty
        image={<Icon name={icon} className="h-28 w-28 text-gray-medium" />}
        description={
          <div className="flex flex-row items-center gap-2">
            <Spin size="small" spinning={isLoading} />
            <span className="text-gray-dark">{label}</span>
          </div>
        }
      />
    </div>
  );
};

export default EmptyTableOverlay;
